'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: ', '\n    label {\n    cursor: pointer;\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: ', '\n    label {\n    cursor: pointer;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Radio = require('../Radio');

var _Radio2 = _interopRequireDefault(_Radio);

var _lodash = require('lodash.uniqueid');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
  var disabled = _ref.disabled,
      theme = _ref.theme;
  return disabled ? theme.color.disabled : theme.color.textColor;
});

function LabeledRadio(props) {
  var labelText = props.labelText,
      disabled = props.disabled,
      restProps = _objectWithoutProperties(props, ['labelText', 'disabled']);

  var id = (0, _lodash2.default)('radio-');
  return _react2.default.createElement(
    Wrapper,
    { disabled: disabled },
    _react2.default.createElement(_Radio2.default, _extends({ disabled: disabled, id: id }, restProps)),
    _react2.default.createElement(
      'label',
      { htmlFor: id },
      labelText
    )
  );
}

LabeledRadio.propTypes = {
  labelText: _propTypes2.default.string.isRequired,
  disabled: _propTypes2.default.bool
};

LabeledRadio.defaultProps = {
  disabled: false
};

exports.default = LabeledRadio;
LabeledRadio.__docgenInfo = [{
  'description': '',
  'displayName': 'LabeledRadio',
  'methods': [],
  'props': {
    'labelText': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'disabled': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/LabeledRadio/index.js'] = {
    name: 'LabeledRadio',
    docgenInfo: LabeledRadio.__docgenInfo,
    path: 'src/LabeledRadio/index.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/LabeledRadio/index.js
// module id = 178
// module chunks = 1